<template>
  <div
    class="option-object px-4 mt-4"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <!-- START OPTION PANEL-->
    <div
      class="break-words rounded-lg shadow h-full border border-solid  hover:shadow-lg cursor-pointer px-4 pb-4 "
      :style="{ 'background-color': panelColor, 'border-color': borderColor }"
      :class="[borderClass, panelWidthClass, {mouseover: hover}]"
      @click="localClickHandler"
    >
      <!--START MAIN VIEW -->
      <div>
        <div
          v-if="step.allow_many || this.option.selected"
          class="flex flex-row-reverse pt-2 pb-2 md:pb-3"
        >
          <svg-icon
            icon="heroicons/solid/check-circle"
            class="h-4 w-4 md:h-7 md:w-7"
            :style="{ color: checkColor }"
          ></svg-icon>
        </div>

        <div v-else class="h-6 w-6 md:h-12 md:w-12"></div>

        <div>
          <svg-inline
            class="display-block mx-auto cursor-pointer"
            :class="[imageHeightClass]"
            :style="{ color: accentColor }"
            :image="option.image"
            :copyAttrs="true"
          />
        </div>

        <div class="p-4">
          <h5 class="text-gray-700 mb-1 text-base font-semibold text-center">
            <div
              v-text="title"
              class="block mx-auto px-5 text-center"
              :style="{ color: fontColor2, 'font-family': survey.fontFamily }"
            ></div>
          </h5>
          <div>
            <div class="text-sm text-gray-700 text-center">
              <div
                v-text="description"
                class="block mx-auto px-5  text-center"
                :style="{ color: fontColor2, 'font-family': survey.fontFamily }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { FontFamily } from "@/mixins/FontFamily.js";
import SvgInline from "@/components/SvgInline";
import SvgIcon from "@/components/SvgIcon";

export default {
  //mixins: [FontFamily],
  name: "option-display",
  components: { SvgInline, SvgIcon },
  props: ["survey", "step", "option"],
  data() {
    return {
      hover: false,
      // selected: this.option.selected,
    };
  },
  computed: {
    imageHeightClass() {
      return this.step.imageHeightClass;
    },
    borderClass() {
      return this.option.selected
        ? "border-2 border-solid border-blue-300"
        : "border border-solid border-gray-200";
    },
    panelWidthClass() {
      return this.step.panelWidthClass;
    },
    accentColor() {
      return this.survey.accentColor;
    },
    checkColor() {
      if (this.option.selected) {
        return this.accentColor;
      } else {
        return "#d4d7dd";
      }
    },
    fontColor() {
      return this.survey.fontColor;
    },
    fontColor2() {
      return this.survey.fontColor2;
    },
    panelColor() {
      return this.survey.panelColor;
    },
    borderColor() {
      return this.survey.borderColor;
    },
    font() {
      return this.survey.font;
    },
    size() {
      return this.step.size;
    },
    image() {
      return this.option.image;
    },
    title() {
      return this.option.title;
    },
    description() {
      return this.option.description;
    },
  },
  methods: {
    localClickHandler() {
      // The "selected" property in not part of our option model schema,
      // so we need to use Vue.set to initialize the property if it does not already exist
      //this.$set(this.option, "selected", this.selected);

      this.$emit("click", this.option);
    },
  },
};
</script>

<style>
.mouseover {
  /* oopacity: 0.8; */
  transform: scale(1.01);
}
</style>
